import * as React from 'react';

export const useExclusiveAsyncAction = () => {
  const isRunningRef = React.useRef(false);
  const [isRunning, setIsRunning] = React.useState(false);

  const run = React.useCallback(async (action: () => Promise<void>): Promise<boolean> => {
    if (isRunningRef.current) {
      return false;
    }

    isRunningRef.current = true;
    setIsRunning(true);

    try {
      await action();
      return true;
    } finally {
      isRunningRef.current = false;
      setIsRunning(false);
    }
  }, []);

  return { isRunning, run };
};
